import {createRootContextHook} from 'common/util/react';

export const useCurrentProject = createRootContextHook(`currentProject`);
